import React, { useEffect, useState, useRef } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import Swal from "sweetalert2";
import moment from "moment";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

const ManageInventory = () => {
  const [inventory, setInventory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({
    startDate: "",
    endDate: "",
    cityNames: [],
  });
  const [editID, setEditID] = useState("");
  const [cityList, setCityList] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");

  const fetchAllData = async () => {
    try {
      const res = await HomeService.getInventory();

      console.log("IUUYT40", res.data)
      if (res?.status) {
        if (userCity) {
          setInventory(res.data.filter((item) => item?.city[0]._id === userCity).sort((d1, d2) => new Date(d2.date) - new Date(d1.date)) || []);
        } else {
          setInventory(res.data.sort((d1, d2) => new Date(d2.date) - new Date(d1.date)) || []);
        }
      } else {
        toast.error("Failed to fetch inventory.");
      }
    } catch (error) {
      toast.error("Error fetching inventory.");
      console.error("Error fetching inventory:", error);
    } finally {
      setLoading(false);
    }
  };

  const [cities, setCities] = useState([]);
  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      if (res?.status) {
        if (userCity) {
          setCities([res.data.find(item => item._id === userCity)])
          fetchLocalities(userCity)
        } else {
          setCities(res.data);
        }
      } else {
        toast.error("Failed to fetch cities.");
      }
    } catch (error) {
      toast.error("Error fetching cities.");
      console.error("Error fetching cities:", error);
    }
  };

  const [localities, setLocalities] = useState([]);

  // Fetch localities
  const fetchLocalities = async (cityId) => {
    try {
      const res = await HomeService.getLocalities();
      // console.log("HYT71", res);

      if (res?.data) {
        setLocalities(res.data.filter((item) => item?.city?._id === cityId));
      }
    } catch (error) {
      console.error("Error fetching localities:", error);
    }
  }

  // useEffect(() => {
  //   console.log("YTR90",editData.city[0]);
  //   fetchLocalities(editData.city[0])
  // }, [editData?.city])



  const handleEdit = (row) => {
    setIsEdit(true);
    setAllSelected(false)

    const editSection = document.getElementById("edit-section");
    if (editSection) {
      editSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }

    setEditID(row._id);
    fetchLocalities(row.city.map(city => city._id)[0])
    setEditData({
      ...row,
      userId: row?.userDetails._id,
      date: row?.date?.split("T")[0],
      city: row?.city?.map(city => city._id),
      locality: row?.locality?.map(item => item._id),
      price: row?.price,
    });
  };

  const toggleStatus = async (id, currentStatus) => {
    try {
      const newStatus = currentStatus === true ? false : true;
      await HomeService.updateInventoryStatus(id, { status: newStatus });
      fetchAllData();

      // toast.success(`Subscription status updated to ${newStatus}!`);
    } catch (error) {
      toast.error("Failed to update Inventory status.");
      console.error("Error updating status:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {

      const updatedData = {
        userId: editData.userId,
        cityId: editData.city,
        locality: editData.locality,
        price: parseInt(editData.price),
        startDate: editData.startDate,
        endDate: editData.endDate,
        date: editData.date,
        remarks: editData.remarks,
        noOfProperty:editData.noOfProperty,
      }

      console.log("IUY151", updatedData);
      // return

      const res = await HomeService.updateInventory(
        editID,
        updatedData
      );

      if (res) {
        toast.success("Society updated successfully!");
        setIsEdit(false);
        fetchAllData();
      }
    } catch (error) {
      toast.error("Failed to update Society.");
      console.error("Error saving Society:", error);
    }
  };

  const handleCityChange = (e) => {
    const value = e.target.value;
    setEditData((prevData) => ({
      ...prevData,
      cityNames: prevData.cityNames.includes(value)
        ? prevData.cityNames.filter((city) => city !== value)
        : [...prevData.cityNames, value],
    }));
  };



  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: `Delete Subscription?`,
      text: "Are you sure you want to delete this Subscription?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        const res = await HomeService.deleteSubscription(id);
        if (res?.status) {
          Swal.fire("Deleted!", "Subscription has been deleted.", "success");
          fetchAllData()
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to delete Subscription.", "error");
      }
    }
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const columns = [
    {
      name: "Date",
      selector: (row) => moment(row?.date?.split("T")[0]).format("DD-MM-YYYY"),
      sortable: true,
    },
    {
      name: "User",
      selector: (row) => row.userDetails?.fullName || "N/A",
      sortable: true,
    },
    {
      name: "Number of Properties",
      selector: (row) => row?.noOfProperty || "N/A",
      sortable: true,
    },
    {
      name: "Price",
      selector: (row) => row.price,
      sortable: true,
    },
    {
      name: "City",
      selector: (row) => row.city[0]?.name,
      sortable: true,
    },
    {
      name: "Locality",
      selector: (row) => row.locality.map(item => item.name).join(", "),
      wrap: true,
    },
    {
      name: "Remarks",
      selector: (row) => row.remarks,
      wrap: true,
    },
    {
      name: "Status",
      cell: (row) => (
        <button
          className={`btn btn-${row.status ? "success" : "danger"}`}
          onClick={() => toggleStatus(row._id, row.status)}
        >
          {row.status ? "Active" : "Inactive"}
        </button>
      ),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <span title="Edit" onClick={() => handleEdit(row)}>
            <i
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}

            ></i>
          </span>

          {/* <span title="Delete" onClick={() => handleDelete(row._id)}>
            <i
              className="fa-solid fa-trash-can text-danger"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "#477DA5",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span> */}
        </>
      ),
    },
  ];

  const formatDateForDisplay = (date) => {
    if (!date) return ""; // Handle empty or invalid dates
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  };
  const [userList, setUserList] = useState([]);
  const fetchUserList = async () => {
    try {
      const usersResponse = await HomeService.getUsers();

      if (userCity) {
        setUserList(usersResponse.data.filter(item => item?.city._id === userCity))
      } else {
        setUserList(usersResponse?.data || []);
      }
      // setCityList(citiesResponse?.data || []);
    } catch (error) {
      toast.error("Failed to fetch user or city list.");
      console.error("Error fetching data:", error);
    }
  }

  const handleLocalityChange = (e) => {
    const value = e.target.value;
    console.log("UYT172", value);

    setEditData((prevData) => ({
      ...prevData,
      locality: prevData.locality.includes(value)
        ? prevData.locality.filter((item) => item !== value)
        : [...prevData.locality, value],
    }));
  };

  const [allSelected, setAllSelected] = useState(false)
  const handleSelectAllLocations = (e) => {
    // console.log("JUY189", localities, locationIds, e.target.value);
    let allLocalities = localities.map(item => item._id);
    if (allSelected) {
      allLocalities = []
    }
    setEditData((prevData) => ({
      ...prevData,
      locality: allLocalities
    }));
    // setLocationIds(allLocalities)
    setAllSelected(!allSelected)
  };

  // useEffect(() => {
  //   fetchLocalities(editData?.city[0])
  //   setAllSelected(false)
  // }, [editData?.city])

  console.log("JUY345", editData);


  useEffect(() => {
    fetchAllData();
    fetchUserList()
    fetchCities();

  }, []);

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid edit-section">
        {isEdit ? (
          <section className="chartBox_area">
            <h2>Edit Inventory</h2>
            <hr />
            {/* <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 mt-3">
                  <label htmlFor="startDate">
                    Start Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    id="startDate"
                    className="form-control"
                    value={editData.startDate}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        startDate: e.target.value,
                      })
                    }
                    required
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="cities">
                    Cities<span className="text-danger">*</span>
                  </label>
                  <div className="dropdown" ref={dropdownRef}>
                    <button
                      type="button"
                      className="form-control"
                      onClick={toggleDropdown}
                    >
                      {editData.cityNames.length === 0
                        ? "Select Cities"
                        : `${editData.cityNames.length} cities selected`}
                    </button>
                    {isDropdownOpen && (
                      <div className="dropdown-menu-for-city">
                        {cityList.map((city) => (
                          <div key={city._id} className="form-check">
                            <input
                              type="checkbox"
                              id={`city-${city._id}`}
                              value={city.name}
                              checked={editData.cityNames.includes(city.name)}
                              onChange={handleCityChange}
                              className="form-check-input"
                            />
                            <label
                              htmlFor={`city-${city._id}`}
                              className="form-check-label"
                            >
                              {city.name}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="endDate">
                    End Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    id="endDate"
                    className="form-control"
                    value={editData.endDate}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        endDate: e.target.value,
                      })
                    }
                    required
                  />
                </div>
              </div>

              <button type="submit" className="btn btn-primary mt-3">
                Save Changes
              </button>
            </form> */}
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 mt-3">
                  <label htmlFor="user">
                    User<span className="text-danger">*</span>
                  </label>
                  <select
                    id="user"
                    className="form-control"
                    value={editData?.userId}
                    // onChange={(e) => setUserId(e.target.value)}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        userId: e.target.value,
                      })
                    }
                  >
                    <option value="">Select User</option>
                    {userList.map((user) => (
                      <option key={user._id} value={user._id}>
                        {user.fullName}-<h6>{user.email}</h6>
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="endDate">
                    Price<span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    id="amount"
                    className="form-control"
                    value={editData?.price}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        price: e.target.value,
                      })
                    }
                    required
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="cities">
                    City<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    value={editData.city[0]}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        city: [e.target.value],
                      })
                    }
                  >
                    <option value="" disabled>---Select---</option>
                    {cities.map((city, key) => (
                      <option key={key} value={city._id}>
                        {city.name}
                      </option>
                    ))}
                  </select>


                </div>

                <div className="col-md-6 mt-3">
                  <label>
                    Locality<span className="text-danger">*</span>
                  </label>
                  {/* <select
                    className="form-control"
                    value={editData.locality}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        locality: e.target.value,
                      })
                    }
                  >
                    <option value="" disabled>---Select---</option>
                    {localities.map((item, key) => (
                      <option key={key} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </select> */}
                  <div className="dropdown" ref={dropdownRef}>
                    <button
                      type="button"
                      className="form-control"
                      onClick={toggleDropdown}
                    >
                      {editData.locality.length === 0
                        ? "Select Localities"
                        : `${editData.locality.length} localities selected`}
                    </button>
                    {isDropdownOpen && (
                      <div className="dropdown-menu-for-city">
                        <div className="form-check"
                          style={{
                            borderBottom: "solid 1px #eee"
                          }}
                        >
                          <input
                            type="checkbox"
                            id="s_all" // Properly linking with label
                            value="all"
                            checked={allSelected}
                            onChange={handleSelectAllLocations}
                            className="form-check-input"
                          />
                          <label
                            className="form-check-label"
                          >
                            Select all
                          </label>
                        </div>
                        {localities.map((item) => (
                          <div key={item._id} className="form-check">
                            <input
                              type="checkbox"
                              id={`city-${item._id}`}
                              value={item._id}
                              checked={editData.locality.includes(item._id)}
                              onChange={handleLocalityChange}
                              className="form-check-input"
                            />
                            <label
                              htmlFor={`city-${item._id}`}
                              className="form-check-label"
                            >
                              {item.name}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                {/* </div> */}





                <div className="col-md-6 mt-3">
                  <label htmlFor="endDate">
                    Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    id="date"
                    className="form-control"
                    value={editData?.date}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        date: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="endDate">
                    Number of Properties
                  </label>
                  <input
                    type="number"
                    name="noOfProperty"
                    className="form-control"
                    value={editData?.noOfProperty}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        noOfProperty: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="col-md-12 mt-3">
                  <label>
                    Remarks
                  </label>
                  <textarea
                    className="form-control"
                    value={editData?.remarks}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        remarks: e.target.value,
                      })
                    }
                    placeholder="Enter remarks (if any)"
                  ></textarea>

                </div>
              </div>


              <button type="submit" style={{
                background: 'rgb(133, 218, 79)',
                borderRadius: '13px'
              }} className="btn mt-3">
                Save Changes
              </button>
              <button
                type="button"
                className="btn btn-secondary mt-3"
                style={{ marginLeft: "11px" }}
                onClick={() => setIsEdit(false)}
              >
                Cancel
              </button>
            </form>
          </section>
        ) : (
          <>
            <div className="mt-5">
              <div style={headLineStyle} className="page-headline">
                Manage Inventory
              </div>
              <hr />
              <button type="submit" style={{
                background: '#fff',
                border: "solid 2px #85da4f",
                borderRadius: '13px',
                margin: '10px'
              }} className="btn mt-3"
                onClick={() => { navigate("/add-inventory") }}
              >
                Add Inventory
              </button>
              {loading ? (
                <p>Loading...</p>
              ) : (
                <section className="chartBox_area">
                  <DataTable
                    columns={columns}
                    data={inventory}
                    progressPending={loading}
                    pagination
                    highlightOnHover
                  />
                </section>
              )}
            </div>
          </>
        )}


      </div>
    </div>
  );
};

export default ManageInventory;
